import '../public/style.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { createApp } from 'vue'
import App from './App.vue'
import Home from './components/Home'
import About from './components/About'
import Resources from './components/Resources'
import Support from './components/Support'
import * as VueRouter from 'vue-router'
import axios from 'axios'
import { VueReCaptcha } from 'vue-recaptcha-v3';






const routes = [
	{
		path: '/',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		component: About
	},
	{
		path: '/resources',
		component: Resources
	},
	{
		path: '/support',
		component: Support
	}
]

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes
});
const FCCP = createApp(App)
FCCP.config.globalProperties.$axios = axios;
FCCP.use(router)
FCCP.use(VueReCaptcha, { siteKey: "6LehBzEfAAAAAPPpS7UV91VT3FuGjdmDlpWRq9iV" });
FCCP.mount('#app')
